module.exports = __webpack_public_path__ + "static/media/no-rooms.0a65e436.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/no-rooms.svg
// module id = 228
// module chunks = 9